import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import AdministratieMenu from "../../Pages/Admin/menu";
import { update } from "../../Pages/Admin/Gebruikers/Reducers/actions";
import ItemsMenu from "../../Pages/Items/menu";
import EvenementenMenu from "../../Pages/Evemenenten/menu";
import ErvaringenMenu from "../../Pages/Ervaringen/menu";
import BoekingenMenu from "../../Pages/Boekingen/menu";
import CMSMenu from "../../Pages/CMS/menu";
import VacaturesMenu from "../../Pages/Vacatures/menu";
import ArrangementenMenu from "../../Pages/Arrangementen/menu";

const Sitebar = ({ username, token, bedrijven, update }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [selectedBedrijf, setSelectedBedrijf] = useState("");

  const onchangeitem = (e) => {
    const value = e.target.value;
    setSelectedBedrijf(value);
    update(username._id, { bedrijf: value }).then((data) => {
      if (data.type === "GEBRUIKER_ERROR") {
        alert(data.payload);
        return false;
      } else {
        window.location.reload();
      }
    });
  };

  const handleMenuToggle = (menuName) => {
    setActiveMenu(prevMenu => prevMenu === menuName ? null : menuName);
  };

  const handleCloseAllMenus = () => {
    setActiveMenu(null);
  };

  return (
    <aside className="sneat-sidebar">
      <Link to="/" className="sneat-sidebar-brand">
        <div className="sneat-sidebar-header">
          <img src="/brand/logo_small.png" alt="Logo Recraplan" height="32" />
          <span className="logo-text">Recraplan</span>
        </div>
      </Link>
      {/* User Info Panel */}
      {token.role === "admin" && bedrijven.length > 1 && (
        <div className="sneat-user-info pt-0">
          <div className="mt-0">
            <select
              className="form-select form-select-sm"
              value={selectedBedrijf}
              onChange={onchangeitem}
            >
              <option value="">Kies een bedrijf</option>
              {bedrijven.map((bedrijf) => (
                <option key={bedrijf._id} value={bedrijf._id}>
                  {bedrijf.naam}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {/* Navigation Menu */}
      {username.role && (
        <nav className="sneat-menu">
          <div className="menu-header">Hoofdmenu</div>

          <div className="menu-item">
            <Link to="/" className="menu-link" onClick={handleCloseAllMenus}>
              <span className="menu-icon">
                <i className="fas fa-home"></i>
              </span>
              <span className="menu-text">Dashboard</span>
            </Link>
          </div>

          {/* Dynamic Menu Items */}
          <ItemsMenu
            token={token}
            username={username}
            isActive={activeMenu === 'items'}
            onToggle={() => handleMenuToggle('items')}
          />
          <EvenementenMenu
            token={token}
            username={username}
            isActive={activeMenu === 'evenementen'}
            onToggle={() => handleMenuToggle('evenementen')}
          />
          <BoekingenMenu
            token={token}
            username={username}
            isActive={activeMenu === 'boekingen'}
            onToggle={() => handleMenuToggle('boekingen')}
          />
          <ErvaringenMenu
            token={token}
            username={username}
            isActive={activeMenu === 'ervaringen'}
            onToggle={() => handleMenuToggle('ervaringen')}
          />
          <ArrangementenMenu
            token={token}
            username={username}
            isActive={activeMenu === 'arrangementen'}
            onToggle={() => handleMenuToggle('arrangementen')}
          />
          <CMSMenu
            token={token}
            username={username}
            isActive={activeMenu === 'cms'}
            onToggle={() => handleMenuToggle('cms')}
          />
          <VacaturesMenu
            token={token}
            username={username}
            isActive={activeMenu === 'vacatures'}
            onToggle={() => handleMenuToggle('vacatures')}
          />

          <AdministratieMenu
            token={token}
            username={username}
            isActive={activeMenu === 'admin'}
            onToggle={() => handleMenuToggle('admin')}
          />
        </nav>
      )}
    </aside>
  );
};

function mapStateToProps(state) {
  return {
    username: state.auth.user,
    token: state.auth.token,
    profile: state.profile,
    bedrijven: state.bedrijven.items,
  };
}

export default connect(mapStateToProps, { update })(Sitebar);
